import { FieldErrors, UseFormRegister } from "react-hook-form";
import { ChangeStageComment } from "../../../../types/pipeline";

interface Props {
    register: UseFormRegister<ChangeStageComment>;
    errors: FieldErrors<ChangeStageComment>;
}

export function AddCommentsForm({ register, errors }: Props) {
    return (
        <div>
            <label className="text-sm font-semibold">Motivo</label>
            <input 
                {...register("motivo", {
                    required: "El motivo es requerido.",
                })}
                aria-invalid={errors.motivo ? "true" : "false"}
                className="
                    w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                    font-semibold text-gray-600 text-sm"
                type="text" />
                {errors.motivo?.type === "required" && (
                    <p className="valErrorText text-sm">{errors.motivo.message}</p>
                )}

            <label className="text-sm font-semibold">Comentarios</label>
            <textarea
                {...register("comentario")}
                className="
                    w-full h-[100px] rounded-[3px] border-gray-400 border my-1 px-2 
                    font-semibold text-gray-600 text-sm resize-none">
            </textarea>
        </div>
    );
}
